import {ClimbingRoute} from "./ClimbigRoute";
import {DifficultyCategory} from "./UserClimbingEvent";

export enum ClimbigEventType {
  BOULDER = "BOULDER",
  FLASH = "FLASH",
  SIMPLE = "SIMPLE",
  FLASH_ZONE = "FLASH_ZONE",
  CUSTOM = "CUSTOM",
}

export type Difficulty = { difficulty: string, colour?: string };

export const FOR_ALL = "WSZYSCY";
const dificulties = [
  {difficulty: "1", colour: "#ededed"},
  {difficulty: "2", colour: "#99d1cf"},
  {difficulty: "3", colour: "#2B93C7"},
  {difficulty: "4", colour: "#B6B4D9"},
  {difficulty: "5", colour: "#7A5EAF"},
  {difficulty: "6", colour: "#F4C236"},
  {difficulty: "7", colour: "#DA516A"},
  {difficulty: "8", colour: "#313235"}];

export const getDifficultyFor = (routeType: ClimbigEventType, showGrades: boolean): Difficulty[] => {
  if(showGrades){
    return dificulties;
  }
  switch (routeType) {
    case ClimbigEventType.BOULDER:
      return dificulties;
    case ClimbigEventType.FLASH:
    case ClimbigEventType.SIMPLE:
    case ClimbigEventType.CUSTOM:
    case ClimbigEventType.FLASH_ZONE:
      return [
        {difficulty: FOR_ALL, colour: "#99d1cf"},
        {difficulty: DifficultyCategory.LIGHT, colour: "#ededed"}];

    default:
      return [];
  }
}

export class ClimbingEvent {
  constructor(
    public name: string,
    public startDate: number,
    public endDate: number,
    public routes: Array<ClimbingRoute>,
    public moreInfoLink?: string,
    public resultsLink?: string,
    public type: ClimbigEventType = ClimbigEventType.CUSTOM,
    public routesToNrOfClimbes: Map<number, number> = new Map(),
    public allowSection: boolean = false,
    public groups: ClimbingEventGroup[] = [],
    public ageGroups: AgeGroup[] = [],
    public collectCompetitionData: boolean = false,
    public liveResults: boolean = true,
    public useStartAndEndDate: boolean = true,
    public collectUserId: boolean = false,
    public nothingPoints: string = "0",
    public zonePoints?: string,
    public zone2Points?: string,
    public donePoints: string = "3",
    public flashPoints?: string,
    public limit?: number,
    public separateZonePoint: boolean = false,
    public separateFlashPoint: boolean = false,
    public showGrade: boolean = false,
    public showRoutesForUsers: boolean = false,
    public collectHardest: boolean = false
  ) {
  }
}

export class ClimbingEventGroup {
  constructor(
    public id: number | undefined,
    public name: string,
    public startDate: number,
    public endDate: number,
  ) {
  }
}

export class AgeGroup {
  constructor(
    public id: number | undefined,
    public name: string,
    public startYear?: number,
    public endYear?: number,
  ) {
  }
}